/* eslint-disable no-shadow */
export enum URL {
  GET_POSITIONS = 'get-positions',
  GET_BPS_FOR_WAITING_ROOM = 'get-bps-for-waiting-room',
}
